// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AddressOptionalRequest } from './address-optional-request';

// @ts-ignore
import { PreviousAddressRequest } from './previous-address-request';

/** See com.rev360.pms.api.controller.patient.PatientAdditionalInformationRequest */
/* istanbul ignore next */
@GandalfModel
export class PatientAdditionalInformationRequest extends GandalfModelBase {

	@GandalfConstantDecorator(constants.BloodType)
	@GandalfLabel('Blood Type')
	@GandalfProperty({ designType: constants.BloodType })
	bloodType!: constants.BloodType | null;

	@GandalfLabel('Citizenship')
	@GandalfProperty({ designType: Number })
	citizenshipId!: number | null;

	@GandalfLabel('Dominant Eye')
	@GandalfProperty({ designType: Number })
	dominantEyeId!: number | null;

	@GandalfLabel('Dominant Hand')
	@GandalfProperty({ designType: Number })
	dominantHandId!: number | null;

	@GandalfLabel('Driver’s License')
	@GandalfValidator({ sizeString: { message: 'Driver’s License cannot be longer than 20 characters', minLength: 0, maxLength: 20 } })
	@GandalfProperty({ designType: String })
	driversLicense!: string | null;

	@GandalfLabel('Education Level')
	@GandalfProperty({ designType: Number })
	educationLevelId!: number | null;

	@GandalfLabel('Financial Insecurity')
	@GandalfProperty({ designType: Number })
	financialInsecurityId!: number | null;

	@GandalfLabel('Food Insecurity')
	@GandalfProperty({ designType: Number })
	foodInsecurityId!: number | null;

	@GandalfLabel('Housing Insecurity')
	@GandalfProperty({ designType: Number })
	housingInsecurityId!: number | null;

	@GandalfLabel('Marital Status')
	@GandalfProperty({ designType: Number })
	maritalStatusId!: number | null;

	@GandalfLabel('Military Status')
	@GandalfProperty({ designType: Number })
	militaryStatusId!: number | null;

	@GandalfSubRequestLabel('Previous Address')
	@GandalfLabel('Previous Address')
	@GandalfProperty({ designType: PreviousAddressRequest })
	previousAddress!: PreviousAddressRequest | null;

	@GandalfLabel('Previous First Name')
	@GandalfValidator({ sizeString: { message: 'Previous First Name cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	previousFirstName!: string | null;

	@GandalfConstantDecorator(constants.PreviousNameType)
	@GandalfLabel('Previous First Name Type')
	@GandalfProperty({ designType: constants.PreviousNameType })
	previousFirstNameType!: constants.PreviousNameType | null;

	@GandalfLabel('Previous Last Name')
	@GandalfValidator({ sizeString: { message: 'Previous Last Name cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	previousLastName!: string | null;

	@GandalfConstantDecorator(constants.PreviousNameType)
	@GandalfLabel('Previous Last Name Type')
	@GandalfProperty({ designType: constants.PreviousNameType })
	previousLastNameType!: constants.PreviousNameType | null;

	@GandalfLabel('Previous Middle Name')
	@GandalfValidator({ sizeString: { message: 'Previous Middle Name cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	previousMiddleName!: string | null;

	@GandalfConstantDecorator(constants.PreviousNameType)
	@GandalfLabel('Previous Middle Name Type')
	@GandalfProperty({ designType: constants.PreviousNameType })
	previousMiddleNameType!: constants.PreviousNameType | null;

	@GandalfLabel('Previous Name End Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	previousNameEndDate!: Date | null;

	@GandalfLabel('Previous Name Start Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	previousNameStartDate!: Date | null;

	@GandalfLabel('Religion')
	@GandalfProperty({ designType: Number })
	religionId!: number | null;

	@GandalfLabel('Social Connection')
	@GandalfProperty({ designType: Number })
	socialConnectionId!: number | null;

	@GandalfLabel('Stress')
	@GandalfProperty({ designType: Number })
	stressId!: number | null;

	@GandalfSubRequestLabel('Temporary Address')
	@GandalfLabel('Temporary Address')
	@GandalfProperty({ designType: AddressOptionalRequest })
	temporaryAddress!: AddressOptionalRequest;

	@GandalfLabel('Temporary Address End Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	temporaryAddressEndDate!: Date | null;

	@GandalfLabel('Temporary Address Start Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	temporaryAddressStartDate!: Date | null;

	@GandalfLabel('Transportation Insecurity')
	@GandalfProperty({ designType: Number })
	transportationInsecurityId!: number | null;

}
